function deleteElementsByClassAtMaxWidth(className) {
  // Check if the window width is 990px or less
  if (window.innerWidth > 990) {
    // Select all elements with the class name
    const elements = document.querySelectorAll(`.${className}`);

    // Loop through the elements and remove each one
    elements.forEach((element) => {
      element.remove();
    });
  }
}
deleteElementsByClassAtMaxWidth("mob-only-js");

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const activeElementId = document.activeElement.id;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(
          `.price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const variantPickerDestination =
          document.getElementById(`variant-radios-${this.dataset.section}`) ||
          document.getElementById(`variant-selects-${this.dataset.section}`);
        const variantPickerSource =
          html.getElementById(
            `variant-radios-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          ) ||
          html.getElementById(
            `variant-selects-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          );

        if (source && destinations) {
          destinations.forEach((dest) => {
            dest.innerHTML = source.innerHTML;
          });
        }
        if (variantPickerSource && variantPickerDestination)
          variantPickerDestination.innerHTML = variantPickerSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        console.log({ price });
        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        document.querySelector("variant-radios")
          ? this.querySelector(`[for="${activeElementId}"]`).focus()
          : this.querySelector(`#${activeElementId}`).focus();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    const quantityRow = document.getElementById(
      `quantity-row-${this.dataset.section}`
    );

    const buttonWrappers = [productForm, quantityRow];

    buttonWrappers.forEach((buttonWrapper) => {
      if (!buttonWrapper) return;
      const addButton = buttonWrapper.querySelector('[name="add"');
      const addButtonText = buttonWrapper.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    });
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    // Add event listeners to each radio input
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener("change", this.updateOptions.bind(this));
    });

    // Call updateOptions on initialisation to set the selected class on load
    this.updateOptions();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    this.options = fieldsets.map((fieldset) => {
      // Remove the 'selected-element' class from all labels within the fieldset
      fieldset.querySelectorAll("label").forEach((label) => {
        label.classList.remove("selected-element");
      });

      // Find the selected radio and its associated label
      const selectedRadio = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );

      if (selectedRadio) {
        // Add the 'selected-element' class to the label of the selected radio
        const selectedLabel = fieldset.querySelector(
          `label[for="${selectedRadio.id}"]`
        );
        if (selectedLabel) {
          selectedLabel.classList.add("selected-element");
        }

        // Return the value of the selected radio
        return selectedRadio.value;
      }
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

function toggleMegaNavs() {
  const header = document.getElementById("MainHeader");
  const mainNavLi_Items = header.querySelectorAll(".level1-li");
  if (mainNavLi_Items == null) {
    console.log("mainNavItems == null");
    return null;
  }

  const hideMegaNavs = (level1Title) => {
    const megaNavs = document.querySelectorAll(".megaNavDesktop");

    megaNavs.forEach((megaNav) => {
      if (megaNav.dataset.parentTitle != level1Title || level1Title == null) {
        megaNav.style.opacity = 0;
        setTimeout(() => {
          megaNav.style.display = "none";
        }, 150);
      }
      if (megaNav.dataset.parentTitle == level1Title) {
        megaNav.style.display = "block";
        setTimeout(() => {
          megaNav.style.opacity = 1;
        }, 150);
      }
    });
  };

  mainNavLi_Items.forEach((level1Li) => {
    const level1Anchor = level1Li.querySelector(".level1-a");
    const thisMegaNav = level1Li.querySelector(".megaNavDesktop");

    level1Anchor.addEventListener("mouseover", () => {
      if (thisMegaNav == null) {
        hideMegaNavs(null);
        return null;
      }

      hideMegaNavs(thisMegaNav.dataset.parentTitle);
      thisMegaNav.style.display = "block";
    });

    if (thisMegaNav == null) {
      return null;
    }

    thisMegaNav.addEventListener("mouseleave", () => {
      hideMegaNavs(null);
    });
  });
}
toggleMegaNavs();

function youtubeInit() {
  const videoIframes = document.querySelectorAll("[data-ytvideo]");

  if (videoIframes.length > 0) {
    var players = new Array();
    const tag = document.createElement("script");
    const firstScriptTag = document.getElementsByTagName("script")[0];
    const playersData = [...videoIframes].map((videoIframe) => {
      return {
        id: videoIframe.id,
        videoId: videoIframe.dataset.videoid,
        jsclass: videoIframe.dataset.jsclass,
        parentId: videoIframe.dataset.videoParentId,
        autoplay: videoIframe.dataset.autoplay,
        hideShowItems: videoIframe.dataset.hideShowItems,
        functionalSize: videoIframe.dataset.functionalSize,
      };
    });

    tag.src = "https://www.youtube.com/iframe_api";
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = function () {
      if (typeof playersData === "undefined") return;
      for (var i = 0; i < playersData.length; i++) {
        var curplayer = createPlayer(playersData[i]);
        players[i] = curplayer;
      }
    };

    function createPlayer(playerInfo) {
      const defaultPlayer = {
        videoId: playerInfo.videoId,
        playerVars: {
          showinfo: 0,
          rel: 0,
        },
      };

      const parentId = playerInfo.parentId
        ? playerInfo.parentId
        : "noParentElement";

      const ytplayer =
        playerInfo.jsclass != undefined
          ? videoClass(playerInfo.jsclass, playerInfo.videoId, playerInfo)
          : defaultPlayer;

      return new YT.Player(playerInfo.id, ytplayer);
    }

    // string, string, object
    function videoClass(className, videoid, playerInfo) {
      const classMap = {
        MultiVideo: new MultiVideo(),
        AccordionVideoYT: new AccordionVideoYT(),
        AccordionVideoYT2: new AccordionVideoYT2(),
        HeroVideoYT: new HeroVideoYT(),
        HeroVideoMobYT: new HeroVideoMobYT(),
        ImageTextCtasYT: new ImageTextCtasYT(),
        BasicVideoYT: new BasicVideoYT(),
        // add more here
      };

      return classMap[className].ytPlayerOptions(videoid, playerInfo);
    }
  }
}
youtubeInit();

class MultiVideo {
  ytPlayerOptions(videoid, playerInfo) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopUrl,
      },
      events: {
        onReady: (e) => this.ytOnReady(e, playerInfo),
      },
    };
  }
  ytOnReady(e, playerInfo) {
    const playerParent = document.getElementById(playerInfo.parentId);

    if (playerParent != null) {
      const playButton = playerParent.querySelector(".multiVideo-play");
      const imgs = playerParent.querySelectorAll(".video-cover");
      playButton.addEventListener("click", () => {
        imgs.forEach((img) => {
          img.style.display = "none";
        });
        playButton.style.display = "none";
        e.target.playVideo();
      });
    }
  }
}

class AccordionVideoYT {
  ytPlayerOptions(videoid, playerInfo) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopUrl,
      },
      events: {
        onReady: (e) => this.ytOnReady(e, playerInfo),
      },
    };
  }
  ytOnReady(e, playerInfo) {
    const playerParent = document.getElementById(playerInfo.parentId);

    if (playerParent != null) {
      const playButton = playerParent.querySelector(".accordionVideo-play");
      const imgs = playerParent.querySelectorAll(".video-cover");
      playButton.addEventListener("click", () => {
        imgs.forEach((img) => {
          img.style.display = "none";
        });
        playButton.style.display = "none";
        e.target.playVideo();
      });
    }
  }
}

class AccordionVideoYT2 {
  ytPlayerOptions(videoid, playerInfo) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopUrl,
      },
      events: {
        onReady: (e) => this.ytOnReady(e, playerInfo),
      },
    };
  }
  ytOnReady(e, playerInfo) {
    const playerParent = document.getElementById(playerInfo.parentId);
    if (playerParent != null) {
      const playButton = playerParent.querySelector(".accordionVideo-play");
      const imgs = playerParent.querySelectorAll(".video-cover");
      playButton.addEventListener("click", () => {
        imgs.forEach((img) => {
          img.style.display = "none";
        });
        playButton.style.display = "none";
        e.target.playVideo();
      });
    }
  }
}

class HeroVideoYT {
  ytPlayerOptions(videoid, playerInfo) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopUrl,
        controls: 0,
        autohide: 0,
      },
      events: {
        onReady: (e) => this.ytOnReady(e, playerInfo),
        onStateChange: this.ytOnPlayerStateChange,
      },
    };
  }

  ytOnReady(e, playerInfo) {
    if (checkWindowSize("mediumDown")) return null;
    heroVideoYtReadyFunctions(playerInfo, e);
  }
  ytOnPlayerStateChange(e) {
    if (e.data === YT.PlayerState.ENDED) {
      e.target.playVideo();
    }
  }
}

class HeroVideoMobYT {
  ytPlayerOptions(videoid, playerInfo) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopUrl,
        controls: 0,
        autohide: 0,
      },
      events: {
        onReady: (e) => this.ytOnReady(e, playerInfo),
        onStateChange: this.ytOnPlayerStateChange,
      },
    };
  }

  ytOnReady(e, playerInfo) {
    if (!checkWindowSize("mediumDown")) return null;
    heroVideoYtReadyFunctions(playerInfo, e);
  }
  ytOnPlayerStateChange(e) {
    if (e.data === YT.PlayerState.ENDED) {
      e.target.playVideo();
    }
  }
}

class ImageTextCtasYT_helpers {
  /**
   * Event is YT player event
   * @param {Object} data {e: (Event), playerInfo: (Object)}
   */
  constructor(data) {
    const { e, playerInfo } = data;
    this.event = e;
    if (this.event == null || playerInfo == null) {
      console.log("ImageTextCtasYT_helpers e or playerInfo is null");
      return null;
    }
    const { id, videoId, jsclass, parentId } = playerInfo;
    this.parentElement = document.getElementById(parentId);

    if (this.parentElement == null) {
      console.log("ImageTextCtasYT _helpers parentElement null");
      return null;
    }

    this.mediaWrapper = this.parentElement.querySelector(".media-wrapper");
    this.playButton = this.mediaWrapper.querySelector(".itc-play");
    this.stopButton = this.mediaWrapper.querySelector(".itc-stop");
    this.imageWrapper = this.mediaWrapper.querySelector(".this-images");
    this.autoPlay = this.mediaWrapper.querySelector(`[data-autoplay="true"]`);
    this.init();
  }

  init() {
    this.playButton.addEventListener("click", () => {
      this.playVideo();
    });

    this.stopButton.addEventListener("click", () => {
      this.stopVideo();
    });

    if (this.autoPlay) {
      this.playVideo();
      this.event.target.mute();
    }
  }

  fadeInOrOut(element, action, displayStyle = "block") {
    if (!element instanceof Element) return null;
    if (action === "hide") {
      element.style.opacity = 0;

      setTimeout(() => {
        element.style.display = "none";
      }, 200);
      return;
    }

    element.style.display = displayStyle;
    setTimeout(() => {
      element.style.opacity = 1;
    }, 100);
  }

  playVideo() {
    this.fadeInOrOut(this.imageWrapper, "hide");
    this.fadeInOrOut(this.playButton, "hide");
    setTimeout(() => {
      this.fadeInOrOut(this.stopButton, "show");
    }, 200);
    this.event.target.playVideo();
  }

  stopVideo() {
    this.fadeInOrOut(this.imageWrapper, "show");
    this.fadeInOrOut(this.stopButton, "hide");
    setTimeout(() => {
      this.fadeInOrOut(this.playButton, "show");
    }, 200);
    this.event.target.pauseVideo();
  }
}

class ImageTextCtasYT {
  ytPlayerOptions(videoid, playerInfo) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopUrl,
        controls: 0,
        autohide: 0,
      },
      events: {
        onReady: (e) => this.ytOnReady(e, playerInfo),
        onStateChange: (e) => this.ytOnPlayerStateChange(e, playerInfo),
      },
    };
  }

  ytOnReady(e, playerInfo) {
    new ImageTextCtasYT_helpers({ e, playerInfo });
  }

  ytOnPlayerStateChange(e, playerInfo) {
    if (e.data === YT.PlayerState.ENDED) {
      const thisYtHelpers = new ImageTextCtasYT_helpers({ e, playerInfo });
      if (playerInfo.autoplay == "false") {
        thisYtHelpers.stopVideo();
        return;
      }
      e.target.playVideo();
      e.target.mute();
      return;
    }
  }
}

/**
 * returns null if mediaQuery is $x
 * @param {String} mediaQuerySize ["mediumDown", //addMore]
 */
function checkWindowSize(mediaQuerySize) {
  let windowWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  if (mediaQuerySize === "mediumDown") {
    // the start of large is the end of medium
    if (windowWidth < window.mediaQuery.large - 1) return true;
  }

  if (mediaQuerySize === "mediumUp") {
    // mediumUp is the end of medium which is the start of large
    if (windowWidth > window.mediaQuery.large) return true;
  }
  return false;
}

function throttle(callback, time) {
  //initialize throttlePause variable outside throttle function
  let throttlePause;

  //don't run the function if throttlePause is true
  if (throttlePause) return;
  //set throttlePause to true after the if condition. This allows the function to be run once
  throttlePause = true;

  //setTimeout runs the callback within the specified time
  setTimeout(() => {
    callback();

    //throttlePause is set to false once the function has been called, allowing the throttle function to loop
    throttlePause = false;
  }, time);
}

/**
 * Player events shared with HeroVideoYt and HeroVideoMobYt
 * @todo instead use basicVideoFunctions
 * @param {Object} playerInfo
 * @param {ytEvent} ytOnReadyEvent
 */
function heroVideoYtReadyFunctions(playerInfo, ytOnReadyEvent) {
  const playerParent = document.getElementById(playerInfo.parentId);
  const playerElement = document.getElementById(playerInfo.id);
  const images = playerParent.querySelector(".this-images");
  const heroHeader = playerParent.querySelector(".heroVideo-header");
  const heroFooter = playerParent.querySelector(".heroVideo-footer");
  const heroPlayButton = playerParent.querySelector(".heroVideo-play");
  const heroStopButton = playerParent.querySelector(".heroVideo-stop");
  const heroMutedButton = playerParent.querySelector(".hv-volume-mute");
  const heroUnmutedButton = playerParent.querySelector(".hv-volume");

  const init = () => {
    ytOnReadyEvent.target.mute();

    if (playerElement.dataset.autoplay == "true") {
      setTimeout(() => {
        playVideo();
      }, 500);
      ytOnReadyEvent.target.mute();
    }
  };
  init();

  const playVideo = () => {
    playerParent.setAttribute("data-is-playing", 1);
    fadeInOrOut(images, "hide");
    fadeInOrOut(heroHeader, "hide");
    fadeInOrOut(heroFooter, "hide");
    fadeInOrOut(heroPlayButton, "hide");
    setTimeout(() => {
      fadeInOrOut(heroStopButton, "show");
    }, 200);
    ytOnReadyEvent.target.playVideo();
  };

  const stopVideo = () => {
    playerParent.setAttribute("data-is-playing", 0);
    fadeInOrOut(images, "show");
    fadeInOrOut(heroHeader, "show", "grid");
    fadeInOrOut(heroFooter, "show");

    setTimeout(() => {
      fadeInOrOut(heroPlayButton, "show");
    }, 200);
    fadeInOrOut(heroStopButton, "hide");
    ytOnReadyEvent.target.pauseVideo();
  };

  /**
   * Pass 'mute' to show mutebutton pass 'unmute'
   * @param {String} action
   * @returns void
   */
  const muteControl = (action) => {
    if (heroUnmutedButton == null || heroMutedButton == null) return null;

    if (action === "unmute") {
      ytOnReadyEvent.target.unMute();
      fadeInOrOut(heroMutedButton, "hide");
      setTimeout(() => fadeInOrOut(heroUnmutedButton, "show"), 200);
      return;
    }

    ytOnReadyEvent.target.mute();
    fadeInOrOut(heroUnmutedButton, "hide");
    setTimeout(() => fadeInOrOut(heroMutedButton, "show"), 200);
    return;
  };

  heroPlayButton &&
    heroPlayButton.addEventListener("click", () => {
      playVideo();
    });

  heroStopButton &&
    heroStopButton.addEventListener("click", () => {
      stopVideo();
    });

  heroMutedButton &&
    heroMutedButton.addEventListener("click", () => {
      muteControl("unmute");
    });

  heroUnmutedButton &&
    heroUnmutedButton.addEventListener("click", () => {
      muteControl("mute");
    });
}

function fadeInOrOut(element, action, displayStyle = "block") {
  if (!element instanceof Element || element == null) return null;
  if (action === "hide") {
    element.style.opacity = 0;

    setTimeout(() => {
      element.style.display = "none";
    }, 200);
    return;
  }

  element.style.display = displayStyle;
  setTimeout(() => {
    element.style.opacity = 1;
  }, 100);
}

class BasicVideoYT {
  ytPlayerOptions(videoid, playerInfo) {
    return {
      videoId: videoid,
      playerVars: {
        showinfo: 0,
        rel: 0,
        origin: window.shopUrl,
        controls: 0,
        autohide: 0,
        modestbranding: 1,
      },
      events: {
        onReady: (e) => this.ytOnReady(e, playerInfo),
        onStateChange: this.ytOnPlayerStateChange,
      },
    };
  }

  ytOnReady(e, playerInfo) {
    basicVideoFunctions(playerInfo, e);
  }
  ytOnPlayerStateChange(e) {
    if (e.data === YT.PlayerState.ENDED) {
      e.target.playVideo();
    }
  }
}

/**
 * @param {Object} playerInfo See youtubeInit > playersData
 * @param {ytEvent} ytOnReadyEvent
 */
function basicVideoFunctions(playerInfo, ytOnReadyEvent) {
  const { hideShowItems, functionalSize, autoplay } = playerInfo;
  const checkRequestedSize = () => {
    if (functionalSize === undefined || checkWindowSize(functionalSize))
      return true;
    return false;
  };
  if (!checkRequestedSize()) return null;

  const hideShowItemsArray =
    hideShowItems && hideShowItems.split(",").map((item) => item.trim());
  const playerParent = document.getElementById(playerInfo.parentId);
  const playBtn = playerParent.querySelector(".basicVideo-play");
  const stopBtn = playerParent.querySelector(".basicVideo-stop");
  const mutedBtn = playerParent.querySelector(".basicVideo-volume-mute");
  const unmutedBtn = playerParent.querySelector(".basicVideo-volume");

  const init = () => {
    ytOnReadyEvent.target.mute();
    if (autoplay === "true") {
      playVideo();
    }
  };

  const playVideo = () => {
    playerParent.setAttribute("data-is-playing", 1);
    ytOnReadyEvent.target.playVideo();
    hideShowItemsArray &&
      hideShowItemsArray.forEach((element) => {
        fadeInOrOut(playerParent.querySelector(element), "hide");
      });
    fadeInOrOut(playBtn, "hide");
    setTimeout(() => {
      fadeInOrOut(stopBtn, "show");
    }, 200);
  };

  const stopVideo = () => {
    playerParent.setAttribute("data-is-playing", 0);
    hideShowItemsArray &&
      hideShowItemsArray.forEach((element) => {
        fadeInOrOut(playerParent.querySelector(element), "show");
      });

    fadeInOrOut(stopBtn, "hide");
    setTimeout(() => {
      fadeInOrOut(playBtn, "show");
      ytOnReadyEvent.target.pauseVideo();
    }, 200);
  };

  /**
   * Pass 'mute' to show mutebutton pass 'unmute'
   * @param {String} action
   * @returns void
   */
  const muteControl = (action) => {
    if (unmutedBtn == null || mutedBtn == null) return null;

    if (action === "unmute") {
      ytOnReadyEvent.target.unMute();
      fadeInOrOut(mutedBtn, "hide");
      setTimeout(() => fadeInOrOut(unmutedBtn, "show"), 200);
      return;
    }

    ytOnReadyEvent.target.mute();
    fadeInOrOut(unmutedBtn, "hide");
    setTimeout(() => fadeInOrOut(mutedBtn, "show"), 200);
    return;
  };

  playBtn && playBtn.addEventListener("click", () => playVideo());
  stopBtn && stopBtn.addEventListener("click", () => stopVideo());
  mutedBtn && mutedBtn.addEventListener("click", () => muteControl("unmute"));
  unmutedBtn && unmutedBtn.addEventListener("click", () => muteControl("mute"));
  init();
}

/**
 * Copies the secondary Nav items and places
 * the new copy into the mobile nav
 */
function copySecondaryNavToMobile() {
  const secondaryNavItems = document.querySelectorAll(
    "#MainHeader .secondary-menu a"
  );

  const mobileMenuDrawer = document.querySelector(
    "#MainHeader .menu-drawer__menu.list-menu"
  );
  const mobileLiHtml = (linkUrl, linkLabel) => `
  <a href="${linkUrl}" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">${linkLabel}</a>
  `;
  const newAnchorItems = [...secondaryNavItems].map((a) =>
    mobileLiHtml(a.href, a.innerHTML)
  );

  newAnchorItems.forEach((newAnchorItem) => {
    const li = document.createElement("li");
    li.innerHTML = newAnchorItem;
    mobileMenuDrawer.append(li);
  });
}
copySecondaryNavToMobile();

function autoScrollElementTop(element, offset = 150) {
  if (element != null) {
    const position = element.getBoundingClientRect();
    window.scroll({
      top: position.top + window.scrollY - offset,
      left: 0,
      behavior: "smooth",
    });
  }
}

/**
 * Checks URL if it has a param value to "scroll_to"
 * It will find the element and scroll to it
 * @returns void
 */
function scrollToDirectLink() {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const scrollToValue = searchParams.get("scroll_to");
  const scrollToClass = searchParams.get("scroll_class");

  if (scrollToValue == null || scrollToValue == "0") return null;

  const scrollToElement = () => {
    if (!scrollToClass) {
      return document.querySelector(`[data-direct-link="${scrollToValue}"]`);
    }
    let g = document.querySelector(`.${scrollToClass}`);
    setTimeout(() => {
      g = document.querySelector(`.${scrollToClass}`);
    }, 1000);
    return g;
  };

  const scrollElement = scrollToElement();
  console.log({ scrollElement });
  if (scrollElement == null) return null;

  autoScrollElementTop(scrollElement, 100);
}
scrollToDirectLink();

function doCountrySelector() {
  if (customElements.get("country-selector")) return null;
  class CountrySelector extends HTMLElement {
    constructor() {
      super();
      this.dropDown = this.querySelector("ul");
      this.selectedElement = this.querySelector(".selectedFlag");
      this.selectedFlagImg = this.querySelector(".selectedFlag img");
      this.selectedFlagText = this.querySelector(".selectedFlag span");
      this.allCountryLinks = this.querySelectorAll(".countrySelectorAnchor");
      this.init();
    }

    init() {
      this.findCurrentFlag();
      this.selectedElement.addEventListener("mouseover", () => {
        this.showDropdown();
      });
      this.dropDown.addEventListener("mouseleave", () => {
        this.hideDropdown();
      });

      this.selectedElement.addEventListener("click", () => {
        if (this.dataset.dropdownActive == "false") {
          this.showDropdown();
          return;
        }
        this.hideDropdown();
      });

      // document.addEventListener("click", (e) => {
      //   if (this.isClickOutsideElement(this.dropDown, e)) {
      //     this.hideDropdown();
      //   }
      // });
    }

    findCurrentFlag() {
      const foundCountry = Array.from(this.allCountryLinks).find(
        (countryLink) => this.dataset.currentIso == countryLink.dataset.iso
      );

      foundCountry.setAttribute("data-active", "true");
      this.selectedFlagImg.src = foundCountry.querySelector("img").src;
      this.selectedFlagText.innerHTML = foundCountry.dataset.text;
    }

    showDropdown() {
      this.setAttribute("data-dropdown-active", true);
      this.dropDown.style.display = "block";
      setTimeout(() => {
        this.dropDown.style.opacity = 1;
      }, 300);
      return;
    }
    hideDropdown() {
      this.setAttribute("data-dropdown-active", false);
      this.dropDown.style.opacity = 0;
      setTimeout(() => {
        this.dropDown.style.display = "none";
      }, 300);
    }
    isClickOutsideElement(element, event) {
      return !element.contains(event.target);
    }
  }
  customElements.define("country-selector", CountrySelector);
}
doCountrySelector();

function noEcommerceClass() {
  if (window.themeHidePurchase) {
    document.body.setAttribute("data-show-ecommerce", "false");
  }
}
noEcommerceClass();

// hot temp fix, the proper wipfix is on bug-us/croMobAutoSelectVariant
// this just adds a check to the radio input which allows the highlight background.
function checkFirstRadioIfNoneSelected() {
  // Get all radio buttons within the options-wrapper
  const radios = document.querySelectorAll(
    '.mob-only-js .options-wrapper-cro input[type="radio"]'
  );

  // Check if none of the radios are checked
  const noneChecked = Array.from(radios).every((radio) => !radio.checked);

  // If none are checked, check the first one
  if (noneChecked && radios.length > 0) {
    radios[0].checked = true;
  }
}

// Call the function to check on page load or desired event
document.addEventListener("DOMContentLoaded", checkFirstRadioIfNoneSelected);
